import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { confirmSubscription } from '../api/subscribers';

type State = 'loading' | 'success' | 'error';

export default function ConfirmPage() {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState<State>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setState('error');
      setMessage('Invalid confirmation link — the token is missing.');
      return;
    }
    confirmSubscription(token)
      .then((res) => {
        setState('success');
        setMessage(res.message);
      })
      .catch((err: Error) => {
        setState('error');
        setMessage(err.message ?? 'Invalid or expired confirmation link.');
      });
  }, [searchParams]);

  return (
    <div style={{ maxWidth: 480, margin: '48px auto', padding: '0 16px', textAlign: 'center' }}>
      {state === 'loading' && (
        <>
          <h1>Confirming…</h1>
          <p style={{ color: 'var(--text-muted)' }}>
            Please wait while we confirm your subscription.
          </p>
        </>
      )}
      {state === 'success' && (
        <>
          <h1 style={{ color: 'var(--success-text)' }}>Subscription confirmed</h1>
          <p style={{ color: 'var(--text-primary)' }}>{message}</p>
          <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>
            You will receive an email whenever the SkyMap API documentation is updated.
          </p>
        </>
      )}
      {state === 'error' && (
        <>
          <h1 style={{ color: 'var(--danger-text)' }}>Confirmation failed</h1>
          <p style={{ color: 'var(--text-primary)' }}>{message}</p>
          <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>
            If the link has expired, you can{' '}
            <a href="/subscribe" style={{ color: 'var(--accent-text)' }}>
              subscribe again
            </a>
            .
          </p>
        </>
      )}
    </div>
  );
}
